import { translateEntity, LANGUAGES } from '@uefadigital/panenka';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { Translatable, Translated } from '../types';

export const useTranslatedEntity = <T extends Translatable>(entity: T) => {
  const {
    i18n: { language },
  } = useTranslation();

  const lang = useMemo(() => LANGUAGES[language.toUpperCase() as keyof typeof LANGUAGES], [language]);

  return translateEntity(entity, lang) ?? ({} as Translated<T>);
};
